import { createSelector } from 'reselect';

const getRoles = state =>
  (state.account.user && state.account.user.rolesList) || [];
const getHotels = state => state.hotels.data;
const getSelectedHotelId = state => state.hotels.selected;
const getLoggedUser = state => state.account.user || {};

const getUsers = state => state.users.data;

const hasRole = role =>
  createSelector(
    [getRoles],
    roles => !!roles.find(r => r === role)
  );

export const isAdmin = hasRole('HotelAdmin');

export const isCleanerSelector = hasRole('Cleaner');

export const isSynchronizing = createSelector(
  [getRoles, getHotels],
  (roles, hotels) =>
    !!roles.find(r => r === 'KWHotelUser') ||
    (hotels.length > 0 && hotels[0].hotelMapping !== null)
);

export const isDemo = createSelector(
  [getLoggedUser],
  user => user.email === 'demo'
);

export const getUsersForSelectedHotel = createSelector(
  [getUsers, getSelectedHotelId],
  (users, hotelId) =>
    users.filter(user => user.hotelIds.find(id => id === hotelId))
);

export const getCleaners = createSelector(
  [getUsersForSelectedHotel],
  users => users.filter(user => user.rolesList.find(role => role === 'Cleaner'))
);



// WEBPACK FOOTER //
// ./src/users/selectors.js